interface ChatBubbleProps {
  message: string;
}

function ChatBubble({ message }: ChatBubbleProps) {
  return (
    <div
      id="chat-bubble"
      className="bg-gradient-chat-bubble animate-fadeIn relative overflow-hidden rounded-2xl px-6 py-5 text-[17px] leading-relaxed wrap-break-word text-white shadow-[0_4px_12px_rgba(6,182,212,0.3)] before:pointer-events-none before:absolute before:inset-0 before:bg-linear-to-br before:from-white/10 before:to-white/0 before:content-[''] sm:px-5 sm:py-[18px] sm:text-base dark:shadow-[0_4px_12px_rgba(21,94,117,0.4)]"
      role="log"
      aria-live="polite"
      aria-label="Chatbot messages"
    >
      {message}
    </div>
  );
}

export default ChatBubble;
